/*
 * Copyright (c) 2014-2023 Comparatio
 */

import { Component } from '@angular/core';
import {environment} from '../../../environments/environment';
import {versionInfo} from '../../version-info';

@Component({
    selector: 'app-footer',
    templateUrl: './app-footer.component.html'
})
export class AppFooterComponent {
    public currentYear: number;
    public versionLabel: string;

    constructor() {
        this.currentYear = (new Date()).getFullYear();
        if (environment.production) {
            this.versionLabel = versionInfo.number;
        } else {
            this.versionLabel = 'Test - ' + versionInfo.number;
        }
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/app-footer/app-footer.component.ts